/* Swap the product page hero image when a size (variant) is selected.
   Uses each variant's own image (variant.featured_media) from the
   product JSON already printed in sections/main-product.liquid. */
(function () {
  function sized(src, width) {
    if (!src) return src;
    try {
      var url = new URL(src, window.location.href);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function init(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    var main = root.querySelector('[data-gallery-main]');
    if (!jsonEl || !main) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!product || !product.variants || product.variants.length < 2) return;

    var idInput = root.querySelector('form input[name="id"]');
    var radios = root.querySelectorAll('input[type="radio"][name^="option-"]');

    function selectedVariant() {
      var chosen = [];
      radios.forEach(function (r) {
        if (r.checked) {
          var pos = parseInt(r.name.replace('option-', ''), 10);
          chosen[pos - 1] = r.value;
        }
      });
      var match = null;
      if (chosen.length) {
        match = product.variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return chosen[i] === undefined || chosen[i] === opt;
          });
        });
      }
      if (!match && idInput) {
        var id = parseInt(idInput.value, 10);
        match = product.variants.find(function (v) { return v.id === id; });
      }
      return match;
    }

    function showVariantImage() {
      var variant = selectedVariant();
      if (!variant || !variant.featured_media || !variant.featured_media.preview_image) return;
      var src = variant.featured_media.preview_image.src;
      var img = main.querySelector('img');
      if (!img || !src) return;

      img.src = sized(src, 900);
      img.srcset = sized(src, 600) + ' 600w, ' + sized(src, 900) + ' 900w, ' + sized(src, 1200) + ' 1200w';
      img.alt = variant.featured_media.alt || product.title;

      // Highlight the matching thumbnail, if one is shown.
      var base = src.split('?')[0];
      root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        var same = (t.getAttribute('data-src') || '').split('?')[0] === base;
        t.classList.toggle('is-active', same);
      });

      // Keep the sticky add-to-cart thumbnail in step.
      var sticky = document.querySelector('.sticky-atc__img');
      if (sticky) sticky.src = sized(src, 96);
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        // Let the theme update the hidden variant id first.
        setTimeout(showVariantImage, 0);
      });
    });

    // Page opened with ?variant=... : show that size's image straight away.
    if (/[?&]variant=/.test(window.location.search)) showVariantImage();
  }

  function run() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      init(form.closest('.page-width') || form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
